import * as R from "ramda";
const parseAgencies = ({ data }) => R.reduce(
  (agencies, scheme) => {
    const parent = scheme.agencyID;
    const children = R.map(
      (agency) => {
        const code = agency.id;
        const id = `${parent}.${code}`;
        const name = R.prop("name")(agency);
        return { id, code, name, parent };
      },
      R.propOr([], "agencies", scheme)
    );
    return R.mergeRight(agencies, R.indexBy(R.prop("id"), children));
  },
  {},
  R.propOr([], ["agencySchemes"], data)
);
export {
  parseAgencies
};
